import * as React from "react";
import { IPermissionListViewProps } from "Components/PermissionList/interfaces-permission-list";
import PermissionListContainer from "Components/PermissionList/permission-list-container";

export default function PermissionListView(props: IPermissionListViewProps) {
  return <PermissionListContainer client={props.client} />;
}
